<template>
  <div class="home-game bg-ui-panel grey100--text d-flex">
    <v-row align="center" no-gutters class="game-card-layout">
      <v-col cols="4">
        <v-img
          class="wheel"
          :src="require('@/assets/img/games/wheel/wheel.png')" contain
          width="80%" aspect-ratio="1"
        />
      </v-col>
      <v-col cols="8" class="pl-4">
        <div class="game-info mb-1">
          <h3 class="text-uppercase grey100--text text-h6 font-weight-bold">
            Wheel of Fortune
          </h3>
          <p class="text--secondary text-body-1">
            The original you know and love
          </p>
        </div>


        <h5 class="game-stats text-body-2 text--secondary d-flex align-center">
          {{ players }} players betting
          <scrap :amount="bet" class="ml-2 text-caption text--secondary" />
        </h5>
      </v-col>
    </v-row>

    <div v-if="xpBonus > 1" class="xp-bonus px-2 py-2 font-weight-bold lh-1 text-caption green700 green200--text">
      +{{ (xpBonus - 1) * 100 | toLocale }}% XP
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: {
      type: Object,
      default: null,
    },
    conga: {
      type: Object,
      default: null,
    },
  },
  computed: {
    players() {
      return this.stats?.players ?? 0
    },
    bet() {
      return this.stats?.total ?? 0
    },
    xpBonus() {
      return this.conga?.games.wheel.xpMultiplier ?? 1
    },
  },
}
</script>

<style lang="scss" scoped>
.home-game {
  position: relative;
  height: 160px;
  cursor: pointer;
  transition: transform 0.3s ease;

  .game-card-layout {
    overflow: hidden;
    position: relative;
  }

  .wheel {
    position: absolute;
    top: 50%;
    left: 0;
    transition: transform 0.8s ease;
    transform: translate(-60%, -50%) rotate(15deg);
  }

  .game-info,
  .game-stats {
    transition: transform 0.6s ease;
  }

  .xp-bonus {
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    background: gold;
    transform: translate(20%, -50%) rotate(-3deg);
  }

  &:hover {
    transform: translateY(-3px);

    .wheel {
      transform: translate(-58%, -50%) rotate(90deg) scale(1.15);
    }

    .game-info {
      transform: translateX(24px) rotate(2deg) scale(1.1);
    }

    .game-stats {
      transform: translateX(24px) rotate(2deg) scale(1.1);
    }
  }
}
</style>
